import { ReplaySubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { LocalStorageService } from 'angular-2-local-storage';

export type AppStatePropTypes = 'collapsedGroups' | 'hiddenTracks' | 'lockedTracks' | 'portfolioSettings' | 'misc';

@Injectable()
export class InteractivityStateService {
	appStateChanged: ReplaySubject<any>;
	appStatePropSubjects: any;

	constructor(private localStorageService: LocalStorageService) {
		this.appStatePropSubjects = {};
		this.appStateChanged = new ReplaySubject(1);
		this.appStateChanged.next(this.getAppState());
	}

	public setPropState(prop: string, value: any) {
		const appState = this.localStorageService.get('bb_ie_app_state') || {};
		appState[prop] = value;
		this.localStorageService.set('bb_ie_app_state', appState);
		if (this.appStatePropSubjects[prop]) {
			this.appStatePropSubjects[prop].next(value);
		}
	}

	public getPropState(prop: AppStatePropTypes) {
		const appState = this.localStorageService.get('bb_ie_app_state') || {};
		return appState[prop] || {};
	}

	public propSub(prop: AppStatePropTypes) {
		this.appStatePropSubjects[prop] = this.appStatePropSubjects[prop] || new ReplaySubject(1);
		this.appStatePropSubjects[prop].next(this.getPropState(prop));
		return this.appStatePropSubjects[prop];
	}

	getAppState() {
		const appState: any = this.localStorageService.get('bb_ie_app_state') || {};
		appState.collapsedGroups = appState.collapsedGroups || {};
		return appState;
	}
}
